<template>
  <section class="add-tratament history-modal flex"
           cy="add-tratament-modal"
           @mousedown="_clickModal">

    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submit)">

        <validation-provider rules="required"
                             v-slot="{ errors }">
          <div class="relative">
            <i class="absolute left0 top0 flex-center"
               v-html="svg.calendar">
            </i>
            <datepicker v-model="data.createdAt"
                        :class="{'invalid-input': errors[0]}"
                        :monday-first="true"
                        :language="$data.ro"
                        :format="_customFormatter"
                        placeholder="data"
                        name="uniquename" />
            <!--            :disabled-dates="$data.disabledDates"-->
          </div>
        </validation-provider>

        <!-- DINTI DD -->
        <div class="mtop12px relative z99">
          <i class="absolute left0 top0 flex-center" v-html="svg.dinti"></i>
          <drop-down :data="ddDinte"
                     :value="data.dinte"
                     @selected="_setDDvalue"/>
        </div>

        <!--  DINTI DD DESTINATIE -->
        <div v-if="showDinteDestinatie"
             class="mtop12px relative z9">
          <i class="absolute left0 top0 flex-center" v-html="svg.dinti"></i>
          <drop-down :data="ddDinteDestinatie"
                     :value="data.dinteDestinatie"
                     @selected="_setDDvalue"/>
        </div>

        <!--  DENUMIRE TRATAMENTE DD -->
        <div class="mtop12px">
          <drop-down
                     :no-results-text="'Nu există tratament cu această denumire'"
                     :data="ddTratament"
                     :value="data.denumire"
                     @selected="setTratament"/>
        </div>

        <!--  MEDIC CURANT -->
        <div class="mtop12px">
          <drop-down :data="ddMedic"
                     :value="data.medic || (user.rol.includes('medic') ? user.nume : '')"
                     @selected="setMedic" />
        </div>

        <textarea class="mtop12px"
                  id="treatment-note"
                  cy="treatment-note"
                  v-model="data.detalii"
                  cols="30" rows="5"
                  placeholder="detalii" />

        <!-- ACTIONS -->
        <div class="actions flex flex-between">
          <div class="flex">
            <upload-img-btn label="inainte"
                            :img="setPic('inainte')"
                            @select-img="selectImg" />
            <div class="mright20px"></div>
            <upload-img-btn label="dupa"
                            :img="setPic('dupa')"
                            @select-img="selectImg" />
          </div>

          <!-- SEMNATURA -->
          <div class="semnatura text-center relative">
            <figure v-if="signature">
              <img :src="signature" alt="">
            </figure>
            <div v-else>
              <button class="flex-center mauto"
                      @click="handleSignature">
                <i v-html="svg.semnatura"></i>
              </button>
              <span v-if="isSemnaturaActiva"><b>semnatura <br> activa</b></span>
              <span v-else>{{ STRINGS.SEMNATURA }}</span>
            </div>
          </div>
        </div>

        <div class="flex flex-between align-center">
          <!-- DELETE -->
          <button v-if="isDeleteBtn"
                  class="delete opa4"
                  @click.stop="promptDelete">
            <i v-html="svg.delete"></i>
          </button>
          <div class="prompt-delete"
               v-if="isDeletePrompt">
            <p>{{ STRINGS.TRATAMENT.CONFIRMARE_STERGERE}}</p>
            <div class="flex flex-between">
              <span class="pointer"
                    @click="promptDelete('no')">NU</span>
              <span class="pointer"
                    @click.stop="deleteTratament">DA</span>
            </div>
          </div>

          <!-- SAVE -->
          <button class="submit flex-center m-left-auto submit-active mright7px"
                  data-test="save-tratament"
                  cy="save-tratament">
            <i v-html="svg.save"></i>
          </button>
        </div>
      </form>
    </ValidationObserver>

    <div class="sterilizare-wrapper flex columns space-between">
      <div class="instrumente-sterilizate">
        <div>
          <p>
            Selectati instrumentele folosite
          </p>

          <Multiselect :value="value"
                       cy="instruments-list"
                       :options="instrumenteSterilizate.map(o => o.id_sterilizare)"
                       @input="handleMultiSelectID" />

          <p v-if="selectedIDs.length">
            Ati selectat instrumentele:
          </p>

          <ul class="chips flex flex-wrap">
            <li class="flex flex-between align-center"
                v-for="({name, id_sterilizare}, index) in selectedIDs"
                :key="index">
              <p>
                {{ id_sterilizare }} - {{ name }}
              </p>

              <i @click="handleRemoveId(id_sterilizare)">
                <svg class="pointer"
                     width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L9 9M1 9L9 1" stroke="#7A928B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </i>
            </li>
          </ul>

          <p v-if="selectedIDs.length">
            Acestea vor fi marcate
            ca folosite dupa ce veti
            salva acest tratament.
          </p>
        </div>
      </div>

      <div class="sterilizari-list" v-if="data.sterilizari">
        <h3>
          Instrumente folosite:
        </h3>
        <ul>
          <li v-for="({name, id_sterilizare, used_at}, index) in data.sterilizari"
              :key="index">
            {{ name }} / {{ id_sterilizare }} / {{ moment(new Date(used_at)).format('MM-DD-YYYY') }}
          </li>
        </ul>
      </div>
    </div>

  </section>
</template>

<script>
  import {STRINGS} from '@/store/strings';
  import {mapState} from 'vuex';
  import {historyModal} from '@/mixins/history-modal';
  import Multiselect from 'vue-multiselect';
  import moment from "moment/moment";

  export default {
    name: 'add-tratament',
    mixins: [historyModal],
    components: { Multiselect },
    data () {
      return {
        value: null,
        selectedInstrumentID: null,
        selectedIDs: [],
        isDeletePrompt: false,
        isDeleteBtn: undefined,
        ddDinte: {
          name: 'dinte',
          placeholder: 'dinte',
          ddData: 'dinti',
          disabled: this.$store.state.disableDintiDD || (this.$store.state.isUpdateModal && this.$store.state.modalData.denumire.includes('punte')),
          validation: false,
          clbk: item => {
            this.$store.commit('SET_DINTI_DESTINATIE', item.replace(' ', '-'))
            this.ddDinteDestinatie.changeable = Math.random()
          }
        },
        ddDinteDestinatie: {
          name: 'dinteDestinatie',
          placeholder: 'dinte destinatie',
          ddData: 'dintiDestinatie',
          changeable: 'some',
          disabled: this.$store.state.isUpdateModal,
          clbk: item => {
            this.$store.commit('SET_PUNTE_DIRECTION', item)
          }
        },
        ddTratament: {
          name: 'denumire',
          placeholder: 'denumire tratament',
          ddData: 'tratamente',
          validation: true,
          allowCustom: false,
          disabled: this.$store.state.isUpdateModal && this.$store.state.modalData.denumire.includes('punte'),
          clbk: item => {
            /* cand selectam punte ca tratament */
            if (item.name.includes('punte')) {
              this.ddDinte.validation = item.dinteDD
              /* aratam dd cu dinte destinatie */
              this.showDinteDestinatie = true
              /* schimbam placeholder dd dinte in dinte origine */
              this.ddDinte.placeholder = 'dinte origine'
              /* filtreaza lista pentru dinti origine */
              this.$store.commit('FILTER_DINTI_ORIGINE')
              /* schimbam pointerul pentru lista de dinti pentru dinte origine catre doar cei cu coroana */
              this.ddDinte.ddData = 'dintiTratamentCoroana'
            } else {
              this.showDinteDestinatie = false
              this.ddDinte.ddData = 'dinti'
              this.ddDinte.placeholder = 'dinte'
              this.$store.commit('REMOVE_KEY_VALUE', {
                sub: 'modalData',
                key: 'dinteDestinatie'
              })
            }
          }
        },
        ddMedic: {
          name: 'medic',
          placeholder: 'medic curant',
          ddData: 'medici',
          validation: true,
          default: '',
          capitalize: true
        },
        submitted: false,
        uploadName: undefined,
        before: false,
        after: false,
        idDelete: false,
        showDinteDestinatie: false,
        STRINGS
      }
    },
    created () {
      this.$store.dispatch('get_medici');
    },
    mounted () {
      this.isDeleteBtn = this.data.denumire
      this.showDinteDestinatie = this.data.dinteDestinatie
    },
    computed: {
      moment () {
        return moment
      },
      ...mapState({
        data: 'modalData',
        pacient: 'pacient',
        isUpdateModal: 'isUpdateModal',
        user: 'user',
        svg: 'svg',
        isSemnaturaActiva: 'isSemnaturaActiva',
      }),
      instrumenteSterilizate () {
        return this.$store.state.instrumenteSterilizate;
      },
      signature () {
        return this.data.signature || this.pacient.signature
      },
      isTratamentInvalid () {
        return this.data.denumire && !this.$store.state.tratamente.some(t => t.name === this.data.denumire)
      }
    },
    methods: {
      handleMultiSelectID (id) {
        const payload = this.instrumenteSterilizate
          .filter(o => +o.id_sterilizare === +id)
          .map(({name, id_sterilizare, _id}) => ({name, id_sterilizare, _id}))
        this.selectedIDs.push({ ...payload[0], used_at: new Date().toISOString() });
      },
      handleRemoveId (id) {
        const index = this.selectedIDs.findIndex(val => +val.id_sterilizare === +id);
        this.selectedIDs.splice(index, 1);
      },
      handleSignature (ev) {
        ev.preventDefault()
        ev.stopPropagation()
        const data = {
          pacientId: this.$router.currentRoute.params.id,
          tratamentId: this.data.id
        }
        this.$store.dispatch('set_signature', data)
      },
      setMedic (data) {
        this.data.medic = data.value
      },
      setPic (field) {
        return this.data.pics.filter(obj => obj.name.indexOf(field) > -1)[0]
      },
      selectImg ({ file, picName }) {
        this.$store.commit('ADD_IMGS_TO_MODAL', { file, picName })
      },
      setTratament ({ value }) {
        this.$store.commit('SET_TRATAMENT', value)
      },
      promptDelete (action) {
        this.isDeletePrompt = action !== 'no'
        this.isDelete = action !== 'no'
      },
      deleteTratament () {
        this.isDelete = true
        const obj = {
          id: this.$router.currentRoute.params.id
        }
        this.$store.dispatch('delete_tratament', obj)
      },
      submit () {
        let obj = {
          id: this.$router.currentRoute.params.id,
          usedInstruments: this.selectedIDs
        }
        if (this.isUpdateModal) {
          !this.isDelete && this.$store.dispatch('update_history', obj)
        }
        else {
          this.$store.dispatch('save_history', obj);
        }
      }
    },
    destroyed () {
      this.$store.commit('RESET_DD_CLONE', { template: this.data.ddData })
      this.$store.commit('SET_KEY_VALUE', { key: 'disableDintiDD', value: false })
      this.$store.commit('SET_KEY_VALUE', { key: 'filterTratamente', value: undefined })
    }
  }
</script>

<style lang="less">
  @import "../assets/styles/mixin";
  @import "../assets/styles/var";
  .add-tratament {
    .semnatura {
      figure {
        position: absolute;
        right: 0;
        top: 0;
        width: 220px;
        img {
          width: 100%;
        }
      }
    }
    .submit,
    .delete,
    .actions {
      margin-top: 20px;
      padding-top: 10px;

    }

    .delete {
      width: 65px;
      height: 65px;
      background-color: white;
      padding: 0;
      cursor: pointer;
      svg path {
        transition: fill .1s ease-in-out;
        fill: @red;
      }
      &:hover {
        background-color: white!important;
        svg path {
          fill: darken(@red, 20%, relative);
        }
      }
    }

    .prompt-delete {
      width: 200px;
      margin-top: 20px;
      text-align: center;
      font-size: 1.3rem;
      div {
        width: 50%;
        margin: 8px auto 0;
        span {
          width: 40px;
          height: 20px;
          padding-top: 4px;
          text-align: center;
          font-weight: bold;
          border-radius: 4px;
          color: white;
          transition: background-color .1s ease-in-out;
          &:first-child {
            background-color: @red;
            &:hover {
              background-color: darken(@red, 20%, relative);
            }
          }
          &:last-child {
            background-color: @main-green;
            &:hover {
              background-color: darken(@main-green, 20%, relative);
            }
          }
        }
      }
    }

    textarea[name="sigImageData"] {
      width: 100%;
      height: 40px;
    }

    .show-signature {
      width: 400px!important;
    }

    .sterilizare-wrapper {
      .instrumente-sterilizate {
        width: 342px;
        padding-top: 24px;
        > div {
          min-height: 340px;
          padding: 12px 22px;
          border-left: 1px solid #c6c6c6;
          p {
            font-size: 1.6rem;
            line-height: 1.3;
          }
          ul.chips {
            margin-top: 12px;
            li {
              margin-bottom: 8px;
              margin-right: 8px;
              padding: 4px 6px;
              font-size: 1.6rem;
              background-color: #e6f8f3;
              border-radius: 4px;
              border: 1px solid #93A6A5;
              p {
                margin-right: 8px;
                font-size: 1.5rem;
                line-height: 1.5;
              }
              i svg:hover {
                transform: scale(1.2);
              }
            }
          }
        }
      }
      .sterilizari-list {
        margin-left: 16px;
        h3 {
          font-size: 1.6rem;
          margin-bottom: 12px;
          opacity: 0.7;
        }
        li {
          font-size: 1.4rem;
          margin-bottom: 6px;
        }
      }
    }

    .multiselect {
      margin: 12px 0 16px;
      .multiselect__input {
        padding-left: 8px;
      }
    }
  }
</style>
